

































import {Component, Prop, Vue} from 'vue-property-decorator'
import {Action} from 'vuex-class'
import Icon from './proxy/Icon.vue'
import Button from './Button.vue'
import Scanner from '../qrScanner'
import {EventBus} from '@/main'
import Img from '@/components/proxy/Image.vue'
import CloseButton from '@/components/CloseButton.vue'
import Container from '@/components/proxy/Container.vue'
import Layout from '@/components/proxy/Layout.vue'

@Component({
  components: {
    Layout,
    Container,
    CloseButton,
    Img,
    Button,
    Icon,
  },
})
export default class QrScanner extends Vue {
  @Action('closePopup') public closePopup: any
  @Prop() public qrImage!: string
  protected flashlightOn: boolean = false
  protected scanner!: Scanner
  protected elements: any = {}

  public scan(err: any, val: string) {
    if (err) {
      return err
    } else {
      if (val.includes('=')) {
        val = val.split('=').reverse()[0]
      }
      EventBus.$emit('qrScanned', val)
      this.close()
    }
  }

  public toggleFlash() {
    if (this.flashlightOn) {
      this.flashlightOn = false
      this.scanner.disableLight()
    } else {
      this.scanner.enableLight()
      this.flashlightOn = true
    }
  }

  protected hideStuff() {
    const getEl = (id: string) => {
      return document.getElementById(id)
    }

    const getStyle = (id: string) => {
      const el = getEl(id)
      if (el) {
        return el.getAttribute('style') || ''
      }
    }

    this.elements = {
      homeview: {
        el: getEl('view-home'),
        style: getStyle('view-home'),
      },
      html: {
        el: document.body.parentElement,
        style: document.body.parentElement!.getAttribute('style'),
      },
      body: {
        el: document.body,
        style: document.body.getAttribute('style'),
      },
      app: {
        el: getEl('app'),
        style: getStyle('app'),
      },
      topbar: {
        el: getEl('topbar')!,
        style: getStyle('style'),
      },
      modalWrapper: {
        el: getEl('modal-wrapper'),
        style: getStyle('modal-wrapper'),
      },
      main: {
        el: document.querySelector('main.v-content'),
        style: document.querySelector('main.v-content')!.getAttribute('style')
      }
    }

    this.elements.homeview.el.setAttribute('style', 'display:none;')
    this.elements.html.el.setAttribute('style', 'background:none transparent !important;')
    this.elements.body.el.setAttribute('style', 'background:none transparent !important;')
    this.elements.app.el.setAttribute('style', 'background:none transparent !important;')
    this.elements.topbar.el.setAttribute('style', 'display:none;')
    this.elements.modalWrapper.el.setAttribute('style', 'background:none transparent !important;backdrop-filter: none;')
    this.elements.main.el.setAttribute('style', 'filter: none !important;')

    this.$on('scannerDestroyed', () => {
      this.elements.homeview.el.setAttribute('style', this.elements.homeview.style)
      this.elements.html.el.setAttribute('style', this.elements.html.style)
      this.elements.body.el.setAttribute('style', this.elements.body.style)
      this.elements.app.el.setAttribute('style', this.elements.app.style)
      this.elements.topbar.el.setAttribute('style', this.elements.topbar.style)
      this.elements.modalWrapper.el.setAttribute('style', this.elements.modalWrapper.style)
      this.elements.main.el.setAttribute('style', this.elements.main.style)
    })
  }

  protected mounted() {
    this.scanner = new Scanner()
    this.scanner.scan(this.scan)
    this.hideStuff()
    this.scanner.show()
  }

  protected beforeDestroy() {
    this.scanner.destroy()
    this.$emit('scannerDestroyed')
  }

  protected close() {
    this.closePopup()
  }
}
